
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-menu-icon',
  imports: [TranslateModule],
  templateUrl: './app-menu-icon.component.html',
  styleUrls: ['./app-menu-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppMenuIconComponent {}
